// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gapsy-tabs_tabContainer__11dOA {
  display: flex;
  /* border-bottom: 2px solid #dee2e6; */
  margin-bottom: 1rem;
}

.gapsy-tabs_tab__1LCIc {
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: 500;
  color: #495057;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.gapsy-tabs_activeTab__0RY\\+\\+ {
  border-bottom: 3px solid #366872;
  color: #366872;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-tabs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB","sourcesContent":[".tabContainer {\r\n  display: flex;\r\n  /* border-bottom: 2px solid #dee2e6; */\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.tab {\r\n  padding: 0.5rem 1rem;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: #495057;\r\n  border-bottom: 3px solid transparent;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.activeTab {\r\n  border-bottom: 3px solid #366872;\r\n  color: #366872;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContainer": `gapsy-tabs_tabContainer__11dOA`,
	"tab": `gapsy-tabs_tab__1LCIc`,
	"activeTab": `gapsy-tabs_activeTab__0RY++`
};
export default ___CSS_LOADER_EXPORT___;
